export default function notificationRun(
  ngNotify
) {

  'ngInject';

  ngNotify
    .addTheme(
      'rapidNotification',
      'rapid-notification'
    );
  ngNotify
    .config({
      theme: 'rapidNotification',
      duration: 3000,
      type: 'info',
      sticky: false,
      html: false
    });

}


/** WEBPACK FOOTER **
 ** ./frontend/bootstrap/notification.run.js
 **/